import React, { useEffect, useState } from "react";
import "./GlobalDialog.css";
import { useGlobalDialog } from "../../../contexts/GlobalDialogContext";
import { CloseX } from "../../../assets/exports/FileExports";

const GlobalDialog = () => {
  const {
    closeDialog,
    component,
    dialogHeading,
    dialogRef,
    isOpen,
    autoFocusOnClose,
  } = useGlobalDialog(); // Access the dialog ref, close function, and dialog open state

  // Effect to trigger showModal() and close() with delay on exit
  useEffect(() => {
    const dialogElement = dialogRef.current;

    if (isOpen) {
      // Open the dialog and trigger fade-in + slide-in animation
      dialogElement.showModal();
      // console.log(
      //   "Console from GlobalDialog.js, autoFocusOnClose = ",
      //   autoFocusOnClose,
      // );
    } else {
      // If the dialog is closing, wait for the fade-out animation to finish
      const timer = setTimeout(() => {
        dialogElement.close(); // Close the dialog after the fade-out animation
      }, 500); // This should match the duration of your fade-out animation
      return () => clearTimeout(timer); // Clean up the timeout on dialog state change
    }
  }, [isOpen, dialogRef]); // Runs when the dialog's open state changes

  // Close the dialog when clicking outside the dialog (optional)
  //   useEffect(() => {
  //     const dialogElement = dialogRef.current;

  //     // Close the dialog when clicking outside the dialog (optional)
  //     const handleOutsideClick = (e) => {
  //       if (e.target === dialogElement) {
  //         closeDialog();
  //       }
  //     };

  //     dialogElement.addEventListener("click", handleOutsideClick);

  //     return () => {
  //       dialogElement.removeEventListener("click", handleOutsideClick);
  //     };
  //   }, [dialogRef, closeDialog]);

  return (
    <dialog ref={dialogRef} className="global-dialog container">
      <div className="dialog-content">
        <div className="dialog-title">
          <h3 className="dialog-heading">{dialogHeading}</h3>
          <button
            type="reset"
            autoFocus={autoFocusOnClose}
            className="dialog-close-button"
            aria-label="Close Dialog"
            onClick={closeDialog}
          >
            <span className="btn-content">
              <CloseX height={18} width={18} />
            </span>
          </button>
        </div>
        <div autoFocus={!autoFocusOnClose}>{component}</div>

        {/* Dynamic content passed as children */}
      </div>
    </dialog>
  );
};

export default GlobalDialog;
